import React,
{
    useState
}
from "react";

import
{
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";


import
{
    faSearch,
    faPen,
    faPlus
}
from "@fortawesome/free-solid-svg-icons";

export default function BuildingBookAssetListPanel(
{
    assets,
    selectedAssetId,
    setSelectedAssetId,
    setDetailsOpen
})
{
    const [searchText,
        setSearchText] =
            useState("");

    const filteredAssets =
        assets.filter(
            function(asset)
            {
                return (
                    asset.code
                        .toLowerCase()
                        .indexOf(
                            searchText.toLowerCase()
                        ) > -1

                    ||

                    asset.name
                        .toLowerCase()
                        .indexOf(
                            searchText.toLowerCase()
                        ) > -1
                );
            }
        );

    return (

        <div style={container}>

            <div style={header}>

                Assets

            </div>

            <div style={searchContainer}>

                <FontAwesomeIcon
                    icon={faSearch}
                    style={searchIcon}
                />

                <input
                    value={searchText}
                    onChange={
                        function(event)
                        {
                            setSearchText(
                                event.target.value
                            );
                        }
                    }
                    placeholder="Search Assets..."
                    style={searchInput}
                />

            </div>

            <div style={assetList}>

                {
                    filteredAssets.map(
                        function(asset)
                        {
                            const selected =
                                asset.id ===
                                selectedAssetId;

                            return (

                                <div
                                    key={asset.id}
                                    style={
                                    {
                                        ...assetRow,

                                        background:
                                            selected
                                            ?
                                            "rgba(90,155,214,0.20)"
                                            :
                                            "transparent"
                                    }}
                                >

                                    <input
                                        type="checkbox"
                                    />

                                    <div
                                        style={assetText}
                                    >

                                        <div
                                            style={assetCode}
                                        >
                                            {asset.code}
                                        </div>

                                        <div
                                            style={assetName}
                                        >
                                            {asset.name}
                                        </div>

                                    </div>

                                    <FontAwesomeIcon

                                        icon={faPen}

                                        style={editIcon}

                                        onClick={
                                            function()
                                            {
                                                setSelectedAssetId(
                                                    asset.id
                                                );

                                                setDetailsOpen(
                                                    true
                                                );
                                            }
                                        }

                                    />

                                </div>

                            );
                        }
                    )
                }

            </div>

            <button

                style={addButton}

                onClick={
                    function()
                    {
                        setSelectedAssetId(
                            null
                        );

                        setDetailsOpen(
                            true
                        );
                    }
                }

            >

                <FontAwesomeIcon
                    icon={faPlus}
                    style={{
                        marginRight: "8px"
                    }}
                />

                Add Asset

            </button>

        </div>

    );
}

const container =
{
    display: "flex",
    flexDirection: "column",
    height: "100%"
};

const header =
{
    padding: "18px 22px",
    fontWeight: "600",
    borderBottom:
        "1px solid rgba(255,255,255,0.08)"
};

const searchContainer =
{
    display: "flex",
    alignItems: "center",
    padding: "16px"
};

const searchIcon =
{
    marginRight: "10px",
    opacity: 0.7
};

const searchInput =
{
    flex: 1,
    background:
        "rgba(255,255,255,0.08)",
    border: "0px",
    borderRadius: "20px",
    padding: "10px 14px",
    color: "#fff",
    outline: "none"
};

const assetList =
{
    flex: 1,
    overflowY: "auto"
};

const assetRow =
{
    display: "flex",
    alignItems: "center",
    padding: "12px 18px",
    borderBottom:
        "1px solid rgba(255,255,255,0.05)"
};

const assetText =
{
    flex: 1,
    marginLeft: "10px"
};

const assetCode =
{
    fontWeight: "600",
    fontSize: "13px"
};

const assetName =
{
    fontSize: "11px",
    opacity: 0.75
};

const editIcon =
{
    cursor: "pointer",
    opacity: 0.7
};

const addButton =
{
    margin: "16px",
    height: "42px",
    borderRadius: "21px",
    border: "0px",
    background:
        "linear-gradient(180deg,#5a9bd6 0%,#417fb7 100%)",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer"
};